export const SOCIAL_NETWORK_URLS = {
    facebook: 'https://www.facebook.com/Bitnetltd/',
    instagram: 'https://instagram.com/bitnet.ge?igshid=YmMyMTA2M2Y=',
    telegram: 'https://t.me/bitnetge',
    linkedin: 'https://ge.linkedin.com/company/bitnet-exchange',
    youtube: 'https://www.youtube.com/@Bitnet-',
    crexoneTelegram: 'https://t.me/crexone',
    crexoneX: 'https://x.com/crexone_io',
    crexoneLinkedin: 'https://www.linkedin.com/company/crexone/',
};
//# sourceMappingURL=socialNetworkUrls.js.map